const customucMenu = [
  {
    icon: "list",
    key: "uc.history",
    name: "Call History",
    description: "Call History",
    url: "home/app/uc/cdr",
    productionReady: true,
  },
  {
    icon: "phone_missed",
    key: "uc.missed-calls",
    name: "Missed calls",
    description: "Missed incoming calls",
    url: "home/app/uc/missed-calls",
    productionReady: true,
  },
  {
    icon: "contacts",
    key: "uc.contacts",
    name: "Contacts",
    description: "Phone Book",
    url: "home/app/uc/contacts",
    productionReady: true,
  },
];
  
  export { customucMenu };
  